import { useMemo } from "react";
import { QuackChat } from "@/components/quack-chat/QuackChat";
import { SessionNotification } from "@/components/quack-chat/core/entities/SessionNotification";
import { useQuackchatPlatformConfiguration } from "@/api/quackchat/configuration/useQuackchatPlatformConfiguration";
import { Flex, Text } from "@radix-ui/themes";

interface NoticeOutputPopupPreviewProps {
  simulatorId?: number;
  previewData: {
    title: string;
    message: string;
    ctaLabel?: string;
  };
}

export function NoticeOutputPopupPreview({
  simulatorId,
  previewData,
}: NoticeOutputPopupPreviewProps) {
  const { data, isLoading } = useQuackchatPlatformConfiguration(
    simulatorId?.toString()
  );

  const sessionNotification = useMemo<SessionNotification | undefined>(() => {
    return {
      id: "preview",
      owner: "",
      createdAt: new Date().toISOString(),
      title: previewData.title || "Title",
      message: previewData.message || "Message",
      ctaLabel: previewData.ctaLabel || "I understand",
      enabled: true,
    };
  }, [previewData.title, previewData.message, previewData.ctaLabel]);

  if (!simulatorId) {
    return (
      <Flex
        align="center"
        justify="center"
        style={{ height: "400px", width: "100%" }}
      >
        <Text size="2" color="gray">
          Select a simulator to preview
        </Text>
      </Flex>
    );
  }

  if (data == null || isLoading) {
    return <></>;
  }

  return (
    <Flex direction="column" gap="2" align="center">
      <QuackChat config={data} sessionNotification={sessionNotification} />
    </Flex>
  );
}
